module.exports = __webpack_public_path__ + "static/media/29DUNON12.b01f3869.jpg";